import { h } from 'preact';
import htm from 'htm';

const html = htm.bind(h);

export function CardsScreen() {
    return html`
        <div id="cards-screen" class="screen" style="display: none;">
            <div class="cards-container">
                <canvas id="pdf-render"></canvas>
                <div class="cards-controls">
                    <button id="prev-card" class="control-btn" aria-label="Previous Card">
                        <svg viewBox="0 0 24 24" width="24" height="24">
                            <path fill="currentColor" d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
                        </svg>
                    </button>
                    <span id="page-num-display"></span>
                    <button id="next-card" class="control-btn" aria-label="Next Card">
                        <svg viewBox="0 0 24 24" width="24" height="24">
                            <path fill="currentColor" d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
                        </svg>
                    </button>
                </div>
                <div id="swipe-instruction" class="instruction-overlay">
                    <span>Swipe to navigate</span>
                </div>
            </div>
        </div>
    `;
}
